import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      innerHTML: _ctx.degree,
      class: "degree"
    }, null, 8, _hoisted_1),
    _createVNode(_component_Modal, {
      ref: "modal",
      title: "Education plans"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "global-degree-modal",
          innerHTML: _ctx.desc
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 512)
  ], 64))
}